module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "title": "Taco Billing",
      "right-visible": false
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Taco Billing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showingSummary = !_vm.showingSummary
            }
          }
        }, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show Summary")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.mine = !_vm.mine;
              _vm.loadInvoices()
            }
          }
        }, on), [_c('v-icon', [_vm._v("account_circle")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Invoices to Me")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.loadInvoices
          }
        }, on), [_c('v-icon', [_vm._v("refresh")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Refresh List")])])], 1), _vm._v(" "), _c('template', {
    slot: "left"
  }, [_c('div', {
    staticClass: "pa-2 lighten-1 ma-2",
    class: {
      green: _vm.isLastMonth(_vm.month), red: !_vm.isLastMonth(_vm.month)
    },
    staticStyle: {
      "border-radius": "30px"
    }
  }, [_c('div', {
    staticClass: "display-flex full-width"
  }, [_c('v-btn', {
    attrs: {
      "color": "white",
      "icon": ""
    },
    on: {
      "click": _vm.decrementMonth
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-left-circle-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "heading center-text mt-1",
    staticStyle: {
      "flex-grow": "1",
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.monthFormatted))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "white",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.incrementMonth(1)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-right-circle-outline")])], 1)], 1)]), _vm._v(" "), (_vm.grandTotal !== 0) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.grandTotal)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                        total for month\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdministrator && _vm.viewingPreviousMonth) ? [(_vm.invoicesNeedingValidation.length) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.invoicesNeedingValidation.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            invoices needing validation\n                        ")])]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": _vm.requestValidationMultiple
    }
  }, [_vm._v("Request")])], 1) : _vm._e(), _vm._v(" "), (_vm.invoicesReadyToSend.length) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.invoicesReadyToSend.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            invoices ready to send\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.processorsReadyToMakeLength) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.processorsReadyToMakeLength) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            processors ready to invoice\n                        ")])]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": _vm.makeInvoiceMultiple
    }
  }, [_vm._v("Make Invoices")])], 1) : _vm._e(), _vm._v(" "), (_vm.insightInvoicesAllSent) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.insightInvoicesPaid.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            insight invoices paid out of " + _vm._s(_vm.insightInvoices.length) + "\n                        ")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "min-width": "100px"
          },
          attrs: {
            "rounded": "",
            "color": "primary"
          },
          on: {
            "click": _vm.emailAllInvoicesToBookkeeper
          }
        }, on), [_vm._v("Bookkeeper")])]
      }
    }], null, false, 4238557427)
  }, [_vm._v(" "), _c('span', [_vm._v("Email Invoices to Bookkeeper")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.invoicesPaid.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            insight invoices paid out of " + _vm._s(_vm.invoices.length) + "\n                        ")])])])] : _vm._e()], 2), _vm._v(" "), (!_vm.invoices.length) ? _c('NoRecordsPlaceholder', {
    attrs: {
      "delay": 2000
    }
  }, [_vm._v("\n                No Invoices\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showingSummary) ? _c('div', {
    staticClass: "white pa-5 rounded ma-3"
  }, _vm._l((_vm.invoicesBySender), function(sender, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm._f("fullName")(sender.from)))]), _vm._v(" "), _vm._l((sender.invoices), function(invoice, formIndex) {
      return _c('div', {
        key: formIndex
      }, [_c('v-icon', [_vm._v("mdi-checkbox-blank-outline")]), _vm._v("\n                    " + _vm._s(_vm._f("fullName")(invoice.to)) + " " + _vm._s(_vm._f("cents")(invoice.total * 1.1)) + " (incl gst)\n                    "), _c('span', {
        staticClass: "light-text"
      }, [_vm._v("(" + _vm._s(_vm.getInvoiceId(invoice)) + ")")]), _vm._v(" "), (_vm.invoiceHasTag(invoice, 'paid')) ? _c('span', [_vm._v(" *** PAID ***")]) : _vm._e()], 1)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.showingSummary) ? _vm._l((_vm.invoicesBySender), function(sender, index) {
    return _c('div', {
      key: index,
      staticClass: "elevation-1 white rounded ma-3 pa-3 no-print-border",
      staticStyle: {
        "max-width": "800px"
      }
    }, [_c('div', {
      staticClass: "display-flex no-print"
    }, [_c('v-avatar', {
      staticClass: "mr-2",
      attrs: {
        "size": "60"
      }
    }, [_c('img', {
      attrs: {
        "src": sender.from.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-col-grow"
    }, [_c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm._f("fullName")(sender.from)))]), _vm._v(" "), (_vm.senderNeedsInvoicing(sender)) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "orange lighten-3",
        "depressed": "",
        "rounded": ""
      },
      on: {
        "click": function($event) {
          return _vm.makeInvoiceSingle(sender)
        }
      }
    }, [_vm._v("\n                        Create Processor Invoice\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "blue--text",
      staticStyle: {
        "font-size": "30px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(sender.consultantTotal)) + "\n                    "), _c('div', {
      staticClass: "element-label center-text full-width text-uppercase",
      staticStyle: {
        "margin-top": "-5px"
      }
    }, [_vm._v(_vm._s(sender.invoices.length) + " Invoice/s")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "grey lighten-4 pa-2 rounded"
    }, _vm._l((sender.invoices), function(invoice) {
      return _c('div', {
        key: invoice.meta.key,
        staticClass: "white rounded ma-2 pa-3"
      }, [_c('div', {
        staticClass: "display-flex no-print"
      }, [_c('div', {
        staticClass: "flex-col-grow"
      }, [_c('div', {
        staticClass: "heading mb-2"
      }, [_vm._v("\n                            " + _vm._s(_vm._f("fullName")(invoice.to)) + "\n                            "), (!_vm.mine) ? _c('v-menu', {
        attrs: {
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({}, on), [_vm._v("keyboard_arrow_down")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.showCharge(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add Charge for " + _vm._s(invoice.to.firstName))])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.resetInvoice(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Reset Workflow")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.populateEntities(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Populate Entities")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.debugInvoice(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Debug Invoice")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.emailMe(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Email Invoice to Me")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.openInvoice(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Open in New Window")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('StatusLine', {
        attrs: {
          "available-stages": _vm.billingStagesVisible
        },
        model: {
          value: (invoice.tags),
          callback: function($$v) {
            _vm.$set(invoice, "tags", $$v)
          },
          expression: "invoice.tags"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-top": "20px"
        }
      }, [_c('div', {
        attrs: {
          "xxstyle": "border:solid 4px #ccc;padding:8px;border-radius:10px;"
        }
      }, [_c('div', {
        staticClass: "heading center-text",
        staticStyle: {
          "padding-top": "18px",
          "margin-left": "8px"
        }
      }, [_vm._v(_vm._s(_vm._f("cents")(invoice.total * 1.1)))])])])]), _vm._v(" "), _c('div', {
        staticClass: "pa-2 no-print"
      }, [((!_vm.isInvoiceReadyToSend(invoice) && (!invoice.meta.preview)) || !_vm.viewingPreviousMonth) ? _c('v-btn', {
        attrs: {
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.previewInvoice(invoice)
          }
        }
      }, [_vm._v("\n                            Preview " + _vm._s(invoice.charges.length) + " Charges\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.viewingPreviousMonth && !_vm.mine) ? [(_vm.isAdministrator && !_vm.invoiceHasTag(invoice, 'validation requested')) ? _c('v-btn', {
        attrs: {
          "color": "blue lighten-3",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.requestValidation(invoice)
          }
        }
      }, [_vm._v("\n                                Request Validation\n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.invoiceHasTag(invoice, 'valid')) ? _c('v-btn', {
        attrs: {
          "color": "blue lighten-3",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.validate(invoice)
          }
        }
      }, [_vm._v("\n                                Validate\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.isInvoiceReadyToSend(invoice)) ? _c('v-btn', {
        attrs: {
          "color": "primary",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.previewInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                Ready To Send\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.invoiceHasTag(invoice, 'sent') && !_vm.invoiceHasTag(invoice, 'paid')) ? [_c('v-btn', {
        attrs: {
          "color": "blue lighten-3",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.markPaid(invoice)
          }
        }
      }, [_vm._v("\n                                    Payment Received\n                                ")])] : _vm._e()] : _vm._e(), _vm._v(" "), (invoice.total === 0 && !_vm.mine) ? _c('v-btn', {
        attrs: {
          "dark": "",
          "color": "red darken-1",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteInvoice(invoice)
          }
        }
      }, [_vm._v("\n                            Delete Invoice\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.isInvoiceReadyToMake(invoice)) ? _c('div', {
        staticClass: "orange--text small-text"
      }, [_vm._v("Ready to Make")]) : _vm._e()], 2), _vm._v(" "), _c('v-expand-transition', [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (invoice.meta.preview),
          expression: "invoice.meta.preview"
        }],
        staticClass: "invoice"
      }, [_c('v-icon', {
        staticClass: "no-print",
        staticStyle: {
          "position": "absolute",
          "right": "5px",
          "top": "5px"
        },
        attrs: {
          "color": "red lighten-3"
        },
        on: {
          "click": function($event) {
            return _vm.$set(invoice.meta, 'preview', false)
          }
        }
      }, [_vm._v("\n                            cancel\n                        ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding": "18px"
        }
      }, [_c('Invoice', {
        key: invoice.meta.key,
        attrs: {
          "invoice": invoice
        },
        on: {
          "delete-charge": _vm.deleteCharge
        }
      })], 1), _vm._v(" "), (!_vm.mine) ? _c('div', {
        staticClass: "center-text no-print pa-3"
      }, [(_vm.invoiceHasTag(invoice, 'valid') && !_vm.invoiceHasTag(invoice, 'sent') && _vm.viewingPreviousMonth) ? [_c('v-btn', {
        staticClass: "no-print",
        attrs: {
          "color": "primary",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.sendInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                    Send Invoice\n                                ")]), _vm._v(" "), _c('a', {
        staticClass: "ml-3 no-print",
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.skipSendInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                    I sent it previously\n                                ")])] : _vm._e(), _vm._v(" "), (_vm.invoiceHasTag(invoice, 'sent')) ? _c('v-btn', {
        staticClass: "no-print",
        attrs: {
          "color": "primary",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.sendInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                Resend Invoice\n                            ")]) : _vm._e()], 2) : _vm._e()], 1)])], 1)
    }), 0)])
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "right"
  }), _vm._v(" "), (_vm.chargeDialog.settings.visible) ? _c('ChargeDialog', {
    attrs: {
      "settings": _vm.chargeDialog.settings,
      "charge": _vm.chargeDialog.charge
    },
    on: {
      "saved": _vm.loadInvoices
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a1443a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Billing/Billing.vue
// module id = 2469
// module chunks = 1